/**
 * Prevents interactive elements being auto-focused on pointer interaction.
 */
export function handleMouseUpByBlurring({ currentTarget }: React.MouseEvent<HTMLElement>): void {
  currentTarget.blur();
}
